import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { MaskedLines, FadeUp } from "@/components/Reveal";

export default function NotFound() {
    return (
        <>
            <Seo title="Page Not Found | Dagaz Development" description="This page does not exist." path="/404" noindex />
            <section className="min-h-[85vh] flex flex-col justify-center px-6 md:px-12 lg:px-16 pt-24 bg-graphite bg-noise" data-testid="not-found-page">
                <MaskedLines
                    lines={["404", "Unbuilt ground."]}
                    as="h1"
                    className="font-serif font-light text-6xl md:text-8xl leading-[0.95] tracking-tight text-chalk"
                />
                <FadeUp delay={0.5} className="mt-10 max-w-md">
                    <p className="font-sans text-base leading-relaxed text-fog">
                        The page you are looking for was never drawn, or has been demolished. The rest of the site is standing.
                    </p>
                </FadeUp>
                <FadeUp delay={0.65} className="mt-12 flex flex-wrap gap-6">
                    <Link
                        to="/"
                        data-testid="not-found-home-link"
                        className="group inline-flex items-center gap-3 px-8 py-4 bg-chalk text-graphite font-sans text-xs font-semibold tracking-[0.22em] uppercase transition-colors duration-500 hover:bg-gold"
                    >
                        Back to Home
                        <span className="inline-block transition-transform duration-500 group-hover:translate-x-1.5" aria-hidden="true">→</span>
                    </Link>
                    <Link to="/services" data-testid="not-found-services-link" className="link-rule self-center font-sans text-xs font-medium tracking-[0.22em] uppercase text-chalk">
                        View Services
                    </Link>
                </FadeUp>
            </section>
        </>
    );
}
